import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { getCRMBaseUrl, getUserCurrentOrganization } from '../../modules/Auth/AuthReducer'
import { getOpportunityUrl } from '../../util/crm-url';

class OpportunityNameRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      value, data, crmBaseUrl, organization,
    } = this.props;
    if (crmBaseUrl && data && data.opportunity_id) {
      const url = getOpportunityUrl(organization, data);
      if (url) {
        return (
          <a rel="noreferrer" target="_blank" href={url}>{value}</a>
        );
      }
    }
    return (
      <span>{value}</span>
    );
  }
}

OpportunityNameRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
  }),
  organization: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
  crmBaseUrl: PropTypes.string,
};
OpportunityNameRenderer.defaultProps = {
  value: null,
  data: null,
  crmBaseUrl: null,
};

function mapStateToProps(state) {
  return {
    crmBaseUrl: getCRMBaseUrl(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(OpportunityNameRenderer);
